<template>
    <div>
        <div
            class="title-topic"
            v-for="item in questions"
            :key="item.questionId"
            :id="item.questionId"
        >
            <el-row>
                <el-row>
                    <div class="topic-tag">
                        <span
                            :class="{ active: marked.indexOf(item.questionId) > -1 }"
                            @click="tagClick(item)"
                        >
                            <i class="el-icon-s-flag"></i>标记
                        </span>
                    </div>
                </el-row>
                <el-row>
                    <div>
                        <span v-text="`${item.questionIndex + 1}、`"></span>
                        <span v-html="item.content.title" class="title-topic-content-title"></span>
                    </div>
                    <div class="topic-list">
                        <!-- 单选题 -->
                        <el-radio-group
                            v-model="item.answer"
                            v-if="questionType === '1'"
                            @change="handleAnswerChange(item)"
                        >
                            <div
                                v-for="(answer, answerKey) in item.content.choiceList"
                                :key="answerKey"
                                class="topic-list-child"
                            >
                                <el-radio :label="answerKey">{{`${answerKey}.${answer}`}}</el-radio>
                            </div>
                        </el-radio-group>
                        <!-- 多选题 -->
                        <el-checkbox-group
                            v-model="item.answer"
                            v-else-if="questionType === '2'"
                            @change="handleAnswerChange(item)"
                        >
                            <div
                                v-for="(answer, answerKey) in item.content.choiceList"
                                :key="answerKey"
                                class="topic-list-child"
                            >
                                <el-checkbox :label="answerKey">{{`${answerKey}.${answer}`}}</el-checkbox>
                            </div>
                        </el-checkbox-group>
                        <!-- 判断题 -->
                        <el-radio-group
                            v-model="item.answer"
                            v-else-if="questionType === '3'"
                            @change="handleAnswerChange(item)"
                        >
                            <div class="topic-list-child">
                                <el-radio label="T">正确</el-radio>
                            </div>
                            <div class="topic-list-child">
                                <el-radio label="F">错误</el-radio>
                            </div>
                        </el-radio-group>
                        <!-- 填空题 -->
                        <el-form ref="form" v-else-if="questionType === '4'">
                            <el-form-item
                                v-for="(answer, answerKey) in item.answer"
                                :key="answerKey"
                            >
                                <el-input
                                    v-model="item.answer[answerKey]"
                                    @change="handleAnswerChange(item)"
                                ></el-input>
                            </el-form-item>
                        </el-form>
                        <!-- 简答题 论述题 分析题 -->
                        <div v-else-if="questionType > 4">
                            <el-input
                                type="textarea"
                                placeholder="请输入内容"
                                :autosize="{ minRows: 3, maxRows: 6 }"
                                v-model="item.answer"
                                @change="handleAnswerChange(item)"
                            ></el-input>
                        </div>
                        <div v-else>other</div>
                    </div>
                </el-row>
            </el-row>
        </div>
    </div>
</template>

<script>
import { updExamineeListDetail } from "@/api/exam/etexam";
export default {
    data() {
        return {
            marked: []
        };
    },
    props: {
        // 题目类型
        questionType: {
            type: String
        },
        // 该类题型的题目列表
        questions: {
            type: Array,
            default: () => {
                return [];
            }
        }
    },
    watch: {
        already: function(val) {
            this.$emit("already-change", val);
        }
    },
    computed: {
        // 已答题id列表
        already: function() {
            let arr = [];
            this.questions.map(item => {
                switch (item.questionTypeId) {
                    case 4:
                        for (let i = 0; i < item.answer.length; i++) {
                            if (item.answer[i] !== "") {
                                arr.push(item.questionId);
                                break;
                            }
                        }
                        break;
                    default:
                        if (!(item.answer === "" || item.answer.length === 0)) {
                            arr.push(item.questionId);
                        }
                        break;
                }
            });
            return arr;
        }
    },
    methods: {
        init() {},
        tagClick(item) {
            let acIndex = this.marked.indexOf(item.questionId);
            if (acIndex > -1) {
                this.marked.splice(acIndex, 1);
            } else {
                this.marked.push(item.questionId);
            }
            this.$emit("marked-change", this.marked);
        },
        handleAnswerChange(question) {
            let { answer, questionId } = question;
            let examHistoryId = Number(this.$route.params.recordId);
            switch (question.questionTypeId) {
                case 2:
                    answer.sort();
                    answer = answer.join("");
                    break;
                case 4:
                    answer = answer.join(",");
                    break;
                default:
                    break;
            }
            updExamineeListDetail({
                answer,
                questionId,
                examHistoryId
            }).then(() => {
                this.$message.success("已保存");
            });
        }
    },
    created() {
        this.init();
    }
};
</script>
<style lang="less">
.title-topic {
    .title-topic-content-title {
        p {
            display: inline-block;
        }
    }
}
</style>
